<template>
  <div id="breadcrumbs" v-if="showBreadcrumbs !== false">
    <nav class="breadcrumb" v-if="!shortBreadcrumbs">
      <a class="breadcrumb-item museumHome" :href="homeURL">{{ $t('BREADCRUMBS_MUSEUM_HOME') }}</a>
      <router-link class="breadcrumb-item active" :to="{ name: 'home' }">{{
        $t('BREADCRUMBS_WEBSHOP')
      }}</router-link>
      <slot></slot>
    </nav>
    <nav class="breadcrumb" v-else>
      <router-link class="breadcrumb-item active" :to="{ name: 'home' }">
        {{ $t('BREADCRUMBS_MUSEUM_HOME') }}
      </router-link>
      <slot></slot>
    </nav>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'BreadcrumbsComponent',
  data() {
    return {
      museumUrl: this.$store.state.app.museumMainUrl,
    };
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
      museumPerLanguageUrls: (state) => state.app.museumPerLanguageUrls,
      showBreadcrumbs: (state) => state.app.showBreadcrumbs,
    }),
    homeURL() {
      let url = `/${this.language}`;
      url = this.museumUrl;
      if (typeof this.museumPerLanguageUrls[this.language] !== 'undefined') {
        url = this.museumPerLanguageUrls[this.language];
      }
      return url;
    },
    shortBreadcrumbs() {
      return this.$store.state.app.shortBreadcrumbs;
    },
  },
};
</script>

<style scoped lang="scss">
.breadcrumb {
  background-color: transparent;
  padding-left: 0px;
  color: $breadcrumb-color;
}
a::after,
:slotted(a::after) {
  content: '/';
  display: inline-block;
  text-decoration: none;
  margin-left: 0.5em;
  margin-right: 0.5em;
}
a,
.router-link-exact-active {
  color: $breadcrumb-color;
}
:slotted(span) {
  color: $breadcrumb-active-color;
}
</style>
